module.exports = (fox) => {
    'use strict';

    fox.registerOptions('~.Api', {
        'secure': fox.getEnv('ah') && [fox.getEnv('ah').split('').reverse().join(''), fox.getEnv('aet')],
    }, true, {code: 'sapi', inline: 1});
}


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/components/sapi/index.es.js